import React from 'react';
import { BannerTypes } from '@gin-betting/banners';
import { get, map } from 'lodash';

import { Carousel } from 'components';
import promo from 'modules/promo';
import useBannersCarousel from './useBannersCarousel';

import './bannerCarousels.scss';

const {
    components: { Banner },
} = promo;

interface Props {
    zoneLocation: BannerTypes.BannerZoneLocation;
}

const BannersCarousel: React.FC<Props> = ({ zoneLocation }) => {
    const { zoneIntervals, banners } = useBannersCarousel({
        zoneLocation,
    });

    if (!banners.length) return null;

    return (
        <React.Fragment>
            {map(banners, ([zoneId, items]) => {
                const delay = get(zoneIntervals, zoneId, undefined);

                if (!items.length) return null;

                return (
                    <div key={zoneId} styleName="container">
                        <Carousel
                            hasControls={false}
                            delay={delay}
                            direction="left"
                        >
                            {map(items, (banner, idx) => (
                                <Banner
                                    key={banner.id ?? idx}
                                    banner={banner}
                                    zoneLocation={zoneLocation}
                                />
                            ))}
                        </Carousel>
                    </div>
                );
            })}
        </React.Fragment>
    );
};

export default React.memo(BannersCarousel);
